module.exports = __webpack_public_path__ + "img/Home Icon - white.50006ce2.svg";